import { DashboardConstants } from '../../actions/constant';

const {
  GET_DASHBOARD_OVERVIEW_REQUEST,
  GET_DASHBOARD_OVERVIEW_FAILURE,
  GET_DASHBOARD_OVERVIEW_SUCCESS,
  GET_DASHBOARD_OVERVIEW_LOADER,
} = DashboardConstants;

const intitialstate: object = {
  response: null,
  isError: false,
  loading: false,
};

export const dashboardOverviewReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_DASHBOARD_OVERVIEW_SUCCESS: {
      return {
        ...state,
        isError: false,
        response: action.payload?.data,
        loading: false,
      };
    }

    case GET_DASHBOARD_OVERVIEW_FAILURE:
      return {
        ...state,
        isError: true,
        errorMessage: action.payload,
        response: null,
        loading: false,
      };

    case GET_DASHBOARD_OVERVIEW_LOADER:
      return {
        ...state,
        loading: true,
      };

    default:
      return state;
  }
};
